import { PublishedAssetType } from "@/graphql/generated/graphql";
import { createAssetUploadHandler } from "@/lib/tiptap-asset-upload";

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

// Takes the workspace rather than reading it globally because the editor is also
// rendered outside a workspace; without it the uploaded bytes are stored but
// attributed to no workspace.
export const createImageUploadHandler = createAssetUploadHandler({
  maxFileSize: MAX_FILE_SIZE,
  assetType: PublishedAssetType.RichTextImage,
});
